/* Fine Plastic Store custom sections: carousel + quick add to cart */
(function () {
  if (window.FinePlasticStore) return;
  window.FinePlasticStore = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- carousel ---------------- */
  class BBCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bb-track');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.dots = this.querySelector('.bb-dots');
      this.center = this.hasAttribute('data-center');
      this.active = 0;

      if (this.dots) {
        this.dots.innerHTML = '';
        if (this.slides.length > 1) {
          this.slides.forEach(function (slide, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bb-dot';
            b.setAttribute('aria-label', 'Show item ' + (i + 1));
            b.addEventListener('click', function () { this.stop(); this.go(i); }.bind(this));
            this.dots.appendChild(b);
          }, this);
        }
      }

      this.onScroll = function () {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(this.update.bind(this));
      }.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      var start = parseInt(this.dataset.start || '0', 10);
      if (start > 0 && start < this.slides.length) {
        requestAnimationFrame(function () { this.go(start, 'auto'); }.bind(this));
      }
      this.update();

      var ms = parseInt(this.dataset.autoplay || '0', 10);
      if (ms > 0 && !reduceMotion && this.slides.length > 1) {
        this.timer = setInterval(this.next.bind(this), ms);
        var stop = this.stop.bind(this);
        ['pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) {
          this.addEventListener(ev, stop, { passive: true });
        }, this);
      }
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.onScroll);
    }

    stop() { clearInterval(this.timer); this.timer = null; }

    offsetFor(i) {
      var s = this.slides[i];
      if (this.center) return s.offsetLeft - (this.track.clientWidth - s.offsetWidth) / 2;
      return s.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
    }

    go(i, behavior) {
      if (!this.slides[i]) return;
      this.track.scrollTo({ left: this.offsetFor(i), behavior: behavior || (reduceMotion ? 'auto' : 'smooth') });
    }

    next() {
      var t = this.track;
      var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      if (atEnd || this.active >= this.slides.length - 1) this.go(0);
      else this.go(this.active + 1);
    }

    update() {
      var t = this.track, best = 0, bestDist = Infinity;
      var ref = this.center ? t.scrollLeft + t.clientWidth / 2 : t.scrollLeft;
      this.slides.forEach(function (s, i) {
        var pos = this.center ? s.offsetLeft + s.offsetWidth / 2 : this.offsetFor(i);
        var d = Math.abs(pos - ref);
        if (d < bestDist) { bestDist = d; best = i; }
      }, this);
      this.active = best;
      this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === best); });
      if (this.dots) {
        Array.prototype.forEach.call(this.dots.children, function (d, i) {
          d.classList.toggle('is-active', i === best);
          d.setAttribute('aria-current', i === best ? 'true' : 'false');
        });
      }
    }
  }
  if (!customElements.get('bb-carousel')) customElements.define('bb-carousel', BBCarousel);


  /* ---------------- random product order (collection banner) ---------------- */
  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = list[i]; list[i] = list[j]; list[j] = t;
    }
    return list;
  }
  function shuffleBanners(scope) {
    (scope || document).querySelectorAll('[data-bb-shuffle]').forEach(function (box) {
      var items = Array.prototype.slice.call(box.children);
      var real = shuffle(items.filter(function (el) { return el.hasAttribute('data-real'); }));
      var rest = shuffle(items.filter(function (el) { return !el.hasAttribute('data-real'); }));
      real.concat(rest).forEach(function (el) { box.appendChild(el); });
    });
  }
  shuffleBanners();
  document.addEventListener('shopify:section:load', function (e) { shuffleBanners(e.target); });

  /* ---------------- toast ---------------- */
  var toastEl, toastTimer;
  function toast(message, link, linkText) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    if (link) {
      var a = document.createElement('a');
      a.href = link;
      a.textContent = linkText || 'View cart';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
  }

  /* ---------------- quick add to cart ---------------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Update the header cart count in Horizon (cart-icon) or Dawn-family themes (#cart-icon-bubble) */
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var icons = document.querySelectorAll('cart-icon');
        icons.forEach(function (el) { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(count); });
        var bubble = document.getElementById('cart-icon-bubble');
        if (!icons.length && bubble) {
          return fetch(root + '?sections=cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var html = data && data['cart-icon-bubble'];
              if (!html) return;
              var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (src) bubble.innerHTML = src.innerHTML;
            });
        }
      })
      .catch(function () { /* count refreshes on next page load */ });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.bbAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'This item could not be added.');
        return refreshCartCount();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        toast('Added to cart. ', root + 'cart', 'View cart');
        document.dispatchEvent(new CustomEvent('bb:cart-updated'));
      })
      .catch(function (err) {
        btn.textContent = label;
        toast(err.message);
      })
      .finally(function () {
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600);
      });
  });
})();
